import React from 'react';
import { ChevronDown } from 'lucide-react';
import type { ScrollToBottomProps } from '../../types/chat';

const ScrollToBottom: React.FC<ScrollToBottomProps> = ({ isVisible, onClick }) => {
  if (!isVisible) return null;

  return (
    <button
      onClick={onClick}
      className={`
        fixed bottom-20 right-6 z-10
        w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white
        rounded-full shadow-lg hover:shadow-xl
        flex items-center justify-center
        transition-all duration-300 ease-in-out
        transform hover:scale-105 active:scale-95
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        animate-fade-in
      `}
      aria-label="Scroll to bottom"
      title="Scroll to latest message"
    >
      <ChevronDown className="w-6 h-6" />
    </button>
  );
};

export default ScrollToBottom;